module.exports = __webpack_public_path__ + "static/media/home-1-img.934c4017.svg";